// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"TimeTableModal_modalContent__JC9w_","deleteModal":"TimeTableModal_deleteModal__3j5JH","boldText":"TimeTableModal_boldText__1rO6r"};